import cx from "clsx";
import SizingContainer from "common-utils/components/SizingContainer";
import { Artwork } from "kreate-common/modules/business-types";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import Link from "next/link";
import React from "react";

import styles from "./index.module.scss";

import CollectionTitleViewer from "@/modules/kreate-components/components/CollectionTitleViewer";
import { ImageViewer } from "@/modules/kreate-components/components/ImageViewer";
import UserDisplayNameViewerV2 from "@/modules/kreate-components/components/UserDisplayNameViewerV2";
import {
  getLinkToPageCollection,
  getLinkToPageProfile,
} from "@/modules/navigation/utils/getLinkTo";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  artwork: Artwork | null | undefined;
};

export default function CollectionTwoLineViewer({
  className,
  style,
  artwork,
}: Props) {
  const avatar = getAvatar(artwork);

  return (
    <div className={cx(styles.container, className)} style={style}>
      <Flex.Row flex="0 1 auto" minWidth="0" gap="12px" alignItems="center">
        <Flex.Row flex="0 0 auto">
          <Link href={avatar?.url || "#disabled"}>
            <SizingContainer
              className={styles.avatarContainer}
              sizing={{ type: "fixed", width: "48px", height: "48px" }}
            >
              <ImageViewer value={avatar?.file} sizing="fill" sizes="48px" />
            </SizingContainer>
          </Link>
        </Flex.Row>
        <Flex.Col flex="1 1 0" minWidth="0">
          <CollectionTitleViewer
            className={styles.collection}
            artist={artwork?.populated?.createdBy}
            collection={artwork?.populated?.collection}
            isUnsortedCollection={!artwork?.collectionId}
            unstyled
          />
          <Flex.Row
            className={styles.artist}
            flex="0 1 auto"
            minWidth="0"
            gap="0.25em"
          >
            <em>{"by"}</em>
            <Flex.Cell asChild minWidth="0">
              <UserDisplayNameViewerV2
                user={artwork?.populated?.createdBy}
                unstyled
              />
            </Flex.Cell>
          </Flex.Row>
        </Flex.Col>
      </Flex.Row>
    </div>
  );
}

function getAvatar(artwork: Artwork | null | undefined) {
  const collection = artwork?.populated?.collection;
  const artist = artwork?.populated?.createdBy;

  if (artwork?.collectionId) {
    return !collection
      ? undefined
      : {
          file: collection.avatar,
          url: getLinkToPageCollection(collection),
        };
  }

  return !artist
    ? undefined
    : {
        file: artist.avatar,
        url: getLinkToPageProfile(artist),
      };
}
